<template>
  <VAppBar
    app
    fixed
    color="white"
    height="60px"
    elevation="3"
    style="z-index: 100;"
  >
    <VRow no-gutters>
      <VCol cols="2" class="mr-auto pa-4">
        <a v-if="company.companyPartnerCode === companyPartnerCodeTypes.ROSTELECOM" href="/" class="logo">
          <svg
            class="hun"
            width="27"
            height="23"
            viewBox="0 0 27 23"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          ><path d="M22.6961 0H22.692C20.8245 0 19.3105 1.56717 19.3105 3.50037V3.50459C19.3105 5.43779 20.8245 7.00496 22.692 7.00496H22.6961C24.5636 7.00496 26.0775 5.43779 26.0775 3.50459V3.50037C26.0775 1.56717 24.5636 0 22.6961 0Z" fill="#EA0D0D" /><path d="M14.8198 5.10547V22.7969H11.3936V17.4979H3.41807V22.8053H0V5.11389H3.41807V13.9596H11.3936V5.11389L14.8198 5.10547Z" fill="#333333" />
          </svg>
          <img class="rt-min" src="../../assets/img/rt/rt-min2.svg" alt="">
        </a>
        <a v-else href="/" class="d-block">
          <svg
            width="27"
            height="23"
            viewBox="0 0 27 23"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          ><path d="M22.6961 0H22.692C20.8245 0 19.3105 1.56717 19.3105 3.50037V3.50459C19.3105 5.43779 20.8245 7.00496 22.692 7.00496H22.6961C24.5636 7.00496 26.0775 5.43779 26.0775 3.50459V3.50037C26.0775 1.56717 24.5636 0 22.6961 0Z" fill="#EA0D0D" /><path d="M14.8198 5.10547V22.7969H11.3936V17.4979H3.41807V22.8053H0V5.11389H3.41807V13.9596H11.3936V5.11389L14.8198 5.10547Z" fill="#333333" />
          </svg>
        </a>
      </VCol>
      <VCol class="d-flex justify-end align-center">
        <button
          type="button"
          class="top-notifications-btn"
          @click="goToNotifications"
        >
          <img
            class="top-notifications-btn__icon"
            :src="notificationsIcon"
            alt="notifications"
          >
          <span v-if="notificationsCount > 0" class="top-notifications-btn__badge">
            {{ notificationsCount }}
          </span>
        </button>

        <VBtnToggle
          v-model="subMenu"
          tile
          group
          color="transparent"
        >
          <VBtn value="menu" color="transparent" class="submenu-mobile__toggle">
            <svg
              width="12"
              height="12"
              viewBox="0 0 12 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                y="0.000976562"
                width="11.9992"
                height="1.19992"
                rx="0.599958"
                fill="#3DB7EB"
              />
              <rect
                y="5"
                width="11.9992"
                height="1.19992"
                rx="0.599958"
                fill="#3DB7EB"
              />
              <rect
                y="10"
                width="11.9992"
                height="1.19992"
                rx="0.599958"
                fill="#3DB7EB"
              />
            </svg>
          </VBtn>
        </VBtnToggle>
      </VCol>
    </VRow>
    <transition name="slide-y-transition">
      <VSheet
        v-show="subMenu === 'menu'"
        color="primary"
        tile
        class="submenu-mobile body-2"
      >
        <VSheet
          color="primary"
          tile
          class="submenu-mobile__content d-flex flex-column justify-space-between"
          height="calc(100% - 60px)"
          width="100%"
        >
          <MenuItems :mini-variant="false" @itemSelect="itemSelect()" />
          <div>
            <MenuContacts mobile />
            <VList
              dense
              nav
              class="py-0 px-0"
              dark
              color="transparent"
            >
              <MenuNotificationsLink @itemSelect="itemSelect()" />
              <MenuSettingsLink @itemSelect="itemSelect()" />
              <MenuLogoutLink />
            </VList>
          </div>
        </VSheet>
      </VSheet>
    </transition>
  </VAppBar>
</template>

<script>
import useCompany from '@/compositions/useCompany';
import useSystemNotifications from '@/compositions/useSystemNotifications';
import { companyPartnerCodeType } from '@/enums';
import MenuItems from './TheMenuItems.vue';
import MenuContacts from './TheMenuContacts.vue';
import MenuNotificationsLink from './TheMenuNotificationsLink.vue';
import MenuSettingsLink from './TheMenuSettingsLink.vue';
import MenuLogoutLink from './TheMenuLogoutLink.vue';

export default {
  name: 'TheMenuMobile',
  components: {
    MenuItems, MenuContacts, MenuNotificationsLink, MenuSettingsLink, MenuLogoutLink,
  },
  data() {
    return {
      miniVariant: true,
      subMenu: '',
      companyPartnerCodeTypes: companyPartnerCodeType,
    };
  },
  computed: {
    notificationsIcon() {
      return require('@/assets/img/menu/notificationsMobile.svg');
    },
  },
  setup() {
    const { company } = useCompany();
    const { unreadCount: notificationsCount } = useSystemNotifications();

    return {
      company,
      notificationsCount,
    };
  },
  methods: {
    itemSelect() {
      this.subMenu = '';
    },
    goToNotifications() {
      this.$router.push({ name: 'notifications' });
    },
  },
};
</script>

<style scoped lang="scss">
  .top-notifications-btn {
    position: relative;
    width: 36px;
    height: 36px;
    border: none;
    background: transparent;
    padding: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }

  .top-notifications-btn__icon {
    width: 24px;
    height: 24px;
    display: block;
  }

  .top-notifications-btn__badge {
    position: absolute;
    top: -2px;
    right: 6px;
    width: 14px;
    height: 14px;
    border-radius: 50px;
    background: #EA0D0D;
    color: #FFFFFF;
    font-size: 9px;
    font-weight: 600;
    line-height: 14px;
    text-align: center;
  }

  .submenu-mobile {
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    height: calc(100vh - 60px);
    box-sizing: border-box;
    &:before {
      content: '';
      bottom: 100%;
      right: 33px;
      border: 10px solid transparent;
      border-bottom-color: #0981d9;
      position: absolute;
      z-index: 5555;
    }
    &__content {
      overflow: auto;
    }
    &__toggle {
      &:before {
        display: none;
      }
    }
  }
  .logo {
    display: block;
    position: relative;
    .hun {
      display: block;
      animation: logo-hun 30s infinite linear;
    }
    .rt-min {
      position: absolute;
      height: 1.75rem;
      left: 2px;
      top: -2px;
      opacity: 0;
      animation: logo-rt 30s infinite linear;
    }
  }
  @keyframes logo-hun {
    from {
      opacity: 0;
    }
    1% {
      opacity: 1;
    }
    48% {
      opacity: 1;
    }
    49% {
      opacity: 0;
    }
    to {
      opacity: 0;
    }
  }
  @keyframes logo-rt {
    from {
      opacity: 0;
    }
    50% {
      opacity: 0;
    }
    51% {
      opacity: 1;
    }
    98% {
      opacity: 1;
    }
    99% {
      opacity: 0;
    }
    to {
      opacity: 0;
    }
  }
</style>
